import { render } from "./OrderDetail.vue?vue&type=template&id=cc386476&ts=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__